module.exports = __webpack_public_path__ + "static/portfolio-mas-4-c9ede54021d631e2080612674ded598f.jpg";